import React from 'react';


export const StageFinancial = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div className="bg-[#F59E0B]/10 border border-[#F59E0B]/30 rounded-lg p-4">
              <p className="text-xs text-white/60">
                <strong className="text-[#F59E0B]">Note:</strong> This section captures high-level financial structure only. Do not enter specific dollar amounts, account numbers, or sensitive financial details.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Child Support Structure</label>
              <div className="space-y-2">
                {[
                  { id: 'plaintiff-pays', name: 'Plaintiff Pays', desc: 'Plaintiff provides child support to defendant' },
                  { id: 'defendant-pays', name: 'Defendant Pays', desc: 'Defendant provides child support to plaintiff' },
                  { id: 'mutual', name: 'Mutual / Offset', desc: 'Calculated based on income disparity and parenting time' },
                  { id: 'per-guidelines', name: 'Per State Guidelines', desc: 'Determined by state child support calculator' },
                  { id: 'none-stated', name: 'Not Addressed Here', desc: 'Support handled separately or by court order' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('childSupport', opt.id); }}
                      className={planData.childSupport === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#10B981] bg-[#10B981]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Uninsured Medical Expenses</label>
                <select value={planData.medicalExpenses} onChange={function(e) { updateData('medicalExpenses', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="">Select arrangement</option>
                  <option value="equal">Split Equally (50/50)</option>
                  <option value="proportional">Proportional to Income</option>
                  <option value="plaintiff">Plaintiff Pays</option>
                  <option value="defendant">Defendant Pays</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Education Expenses</label>
                <select value={planData.educationExpenses} onChange={function(e) { updateData('educationExpenses', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="">Select arrangement</option>
                  <option value="equal">Split Equally</option>
                  <option value="proportional">Proportional to Income</option>
                  <option value="discussed">Discussed Per-Expense</option>
                  <option value="plaintiff">Plaintiff Pays</option>
                  <option value="defendant">Defendant Pays</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Extracurricular Expenses</label>
                <select value={planData.extracurricularExpenses} onChange={function(e) { updateData('extracurricularExpenses', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="">Select arrangement</option>
                  <option value="equal">Split Equally</option>
                  <option value="proportional">Proportional to Income</option>
                  <option value="enrolling-parent">Enrolling Parent Pays</option>
                  <option value="discussed">Discussed Per-Activity</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Clothing & Personal Items</label>
                <select value={planData.clothingPolicy} onChange={function(e) { updateData('clothingPolicy', e.target.value); }}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                  <option value="">Select arrangement</option>
                  <option value="each-home">Each Home Provides Own</option>
                  <option value="travel-with">Clothes Travel With Child</option>
                  <option value="shared">Shared Responsibility</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Tax Dependency Claim</label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { id: 'alternate', label: 'Alternate Years' },
                  { id: 'plaintiff', label: 'Plaintiff Claims' },
                  { id: 'defendant', label: 'Defendant Claims' },
                  { id: 'per-irs', label: 'Per IRS Rules' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('taxDependency', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.taxDependency === opt.id ? 'border-[#10B981] bg-[#10B981]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {planData.taxDependency === 'alternate' && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="tax-alternate-pickers">
                <div>
                  <label className="block text-sm font-medium mb-2">Who claims the child in <span className="text-[#10B981]">EVEN</span> years?</label>
                  <div className="grid grid-cols-2 gap-2">
                    {[
                      { id: 'plaintiff', label: 'Plaintiff' },
                      { id: 'defendant', label: 'Defendant' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('taxEvenYears', opt.id); }}
                          className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                            ((planData.taxEvenYears || 'plaintiff') === opt.id ? 'border-[#10B981] bg-[#10B981]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'tax-even-' + opt.id}>
                          {opt.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Who claims the child in <span className="text-[#10B981]">ODD</span> years?</label>
                  <div className="grid grid-cols-2 gap-2">
                    {[
                      { id: 'plaintiff', label: 'Plaintiff' },
                      { id: 'defendant', label: 'Defendant' },
                    ].map(function(opt) {
                      return (
                        <button key={opt.id} onClick={function() { updateData('taxOddYears', opt.id); }}
                          className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                            ((planData.taxOddYears || 'defendant') === opt.id ? 'border-[#10B981] bg-[#10B981]/10' : 'border-white/10 hover:border-white/20')}
                          data-testid={'tax-odd-' + opt.id}>
                          {opt.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        
  );
};
